import { useIntl } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { CrossBoldIcon, InfoIcon } from '@capsicum/common-web/icons';
import {
	RECEIVE_NETWORK_LABELS,
	RECEIVE_NETWORK_SHORTCODES,
	type ReceiveNetworks,
	useNativeCurrencyNetwork,
	useReceiveDetails
} from '@capsicum/features/wallet/shared';
import { useState } from 'react';

import { AddressCopyCard } from '../../ui';

import { S } from './address.styled';

export const AddressCHZ = () => {
	const { $t } = useIntl();
	const { data: receiveDetails, isLoading: isLoadingReceiveDetails } = useReceiveDetails();
	const { searchParams } = useRouter();
	const [showSnack, setShowSnack] = useState(false);

	const title = $t('wallet.receive.address.titleChiliz');
	const info = $t('wallet.receive.address.infoChiliz');
	const info2 = $t('wallet.receive.address.infoChiliz2');
	const clipboard = $t('wallet.receive.address.clipboard');

	const network = searchParams?.get('network') || '';

	const { data: networkData, isLoading: isLoadingNetwork } = useNativeCurrencyNetwork(network);

	const item = {
		address: networkData?.blockchainAddress,
		label: RECEIVE_NETWORK_LABELS[network as ReceiveNetworks],
		maxAmount: `${receiveDetails?.remainingAmountBeforeLimit?.formattedMaxAmount} CHZ`,
		shortCode: RECEIVE_NETWORK_SHORTCODES[network as ReceiveNetworks]
	};

	const isLoading = isLoadingNetwork || isLoadingReceiveDetails;

	return (
		<S.Container>
			<S.Title>{title}</S.Title>
			<AddressCopyCard isLoading={isLoading} network={item} showSnack={setShowSnack} />
			<S.AlertWrapper closable={false} icon={InfoIcon} testID="receiveCHZ-address-info" type="message">
				<S.TextAmountSkeleton isLoading={isLoading}>
					<S.TextAmount>{item.maxAmount}</S.TextAmount>
				</S.TextAmountSkeleton>
				{` ${info}`}
				{info2}
			</S.AlertWrapper>
			{showSnack && (
				<S.StyledSnackbar
					actionText=""
					description={clipboard}
					rightIcon={CrossBoldIcon}
					testID="receiveCHZ-address-snackbar"
					onActionActivate={() => null}
					onActivate={() => setShowSnack(false)}
					onRightIconActivate={() => setShowSnack(false)}
				/>
			)}
		</S.Container>
	);
};
